import Box from '@mui/material/Box'
import {Select} from '../../1elements'

const DataExportDataSetDropdownBase = ({options, value, onChange}) => {
    return (
        <Box sx={{ width: '60%' }}>
            <Select options={options} helperText={'Select One'} value={value} onChange={onChange}/>
        </Box>
    )
}

export default DataExportDataSetDropdownBase
